import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=3028f7fc&scoped=true&"
import script from "./outbound.vue?vue&type=script&lang=js&"
export * from "./outbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028f7fc",
  null
  
)

export default component.exports